import { FC } from 'react'
import { styles } from './styles'
import { Iframe } from '../../types'

interface TokenexInputProps {
  iframe: Iframe
  icon?: JSX.Element

  label: string
  name?: string
  containerId: string

  onLabelClick: () => void
}

export const TokenexInput: FC<TokenexInputProps> = ({
  iframe,
  icon,

  label,
  containerId,
  name,

  onLabelClick,
}) => {
  return (
    <div css={[styles.container.base, icon && styles.container.withIcon]}>
      {icon}
      <div
        id={containerId}
        css={styles.iframeContainer}
        data-testid={`${name}_iframe_container`}
      />

      <label
        css={[
          styles.label.base,
          iframe.focused && styles.label.top,
          iframe.error && styles.label.error,
        ]}
        onClick={onLabelClick}
      >
        {label}
      </label>

      {iframe.error && (
        <div css={styles.error} id={`${name}_input-error`} data-testid="input-error">
          {iframe.error.charAt(0).toUpperCase() + iframe.error.slice(1)}
        </div>
      )}
    </div>
  )
}
